import React from 'react'
import { Typography } from '@material-ui/core'

export default function CoachName({ hit }) {
  return <Typography variant="body1">{hit.coach_name}</Typography>
}
